export const VendorsPermissions = {
  ViewVendors: {
    permissionsId: "19508e3f-a414-4b64-b6e6-08dd8b9e8c29",
    permissionsName: "View Vendors",
    description: null,
    componentsId: null,
    components: null,
  },
};
